module.exports = __webpack_public_path__ + "img/done-sign.47a993cd.svg";